import { css } from "@linaria/core";
import { colors } from "@ui/Theme";

export const blockItem = css`
  display: grid;
  grid-template-columns: 1fr 32px;
  background-color: ${colors.hydrogen};
  border: 1px solid transparent;
  padding: 16px;
  column-gap: 8px;
  border-radius: 4px;
  height: 100%;
  transition:
    border-color 75ms linear,
    box-shadow 150ms linear;

  &:is(.PLOT, .TABLE, .IMAGE, .DIAGRAM, .TEXT, .PRESET) {
    grid-template-columns: 1fr;
    border-color: ${colors.titanium200};
  }

  &.PRESET {
    min-height: 240px;
  }

  &.TEXT {
    width: inherit;
    overflow: clip;
    contain: inline-size;
    padding: 0;
    border: 0px solid transparent;
    background: transparent;
  }

  &:where(.TEXT, .HEADING).readonly {
    padding-top: 0;
    padding-bottom: 0;
    background-color: transparent;
  }

  &:where(.COMMENT).readonly {
    background-color: transparent;
    padding-left: 0;
    padding-right: 0;
    grid-template-columns: none;
  }
`;

export const blockItemContent = css`
  height: max-content;

  .TEXT & {
    overflow: auto;
  }

  .PLOT & {
    height: 100%;
    min-height: max(60vh, 400px);
    display: flex;
    flex-direction: column;
  }

  .DIAGRAM & {
    height: 100%;
    min-height: 600px;
    display: flex;
    flex-direction: column;
  }
`;
